import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '../../../../actions';
import AdminPanelPage from '../../../presenters/admins/AdminPanelPage/AdminPanelPage';
import { cloneDeep } from 'lodash';
import * as api from '../../../../services/api';
import { Snackbar } from '@material-ui/core';
import normalizeAppConfigs from '../../../../utils/app-config-util';

class AdminPanelContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { appConfigs: props.appConfigs, actionMessage: null };
    this.getData = this.getData.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
  }

  render() {
    return (
      <div>
        <AdminPanelPage
          appConfigs={this.getData()}
          onValueChange={this.onValueChange}
          onSaveChanges={this.onSaveChanges}
        />
        <Snackbar
          open={!!this.state.actionMessage}
          onClose={() => {
            this.setState({ actionMessage: null });
          }}
          autoHideDuration={5000}
          message={this.state.actionMessage}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        />
      </div>
    );
  }

  getData() {
    return Object.entries(this.state.appConfigs).map((ac) => ({
      configurationName: ac[1].name,
      description: ac[1].description,
      value: ac[1].value,
      type: ac[1].type
    }));
  }

  onValueChange(appConfig, newValue) {
    const appConfigsClone = cloneDeep(this.state.appConfigs);
    appConfigsClone[appConfig.configurationName].value = newValue;
    this.setState({ appConfigs: appConfigsClone });
  }

  async onSaveChanges() {
    try {
      // submit changes to backend
      await api.applicationConfigurations.update(this.getData());
      // Retrieve submitted changes from backend
      const response =
        await api.applicationConfigurations.getApplicationConfigurations();
      // update component state and once completed, submit changes to Redux
      const updateAppConfigs = normalizeAppConfigs(response.data);
      this.setState(
        {
          appConfigs: updateAppConfigs,
          actionMessage: 'Success'
        },
        () => this.props.actions.updateAppConfigs(updateAppConfigs)
      );
    } catch (err) {
      this.setState({
        actionMessage: `Failed to save changes`
      });
    }
  }
}

const mapStateToProps = (state) => ({
  appConfigs: state.get('app').toJS().appConfigs
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminPanelContainer)
);
